
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import { PRODUCT_KEYS } from '~/domain/constants/PricingConst'

export default defineComponent({
  name: 'HomePricing',
  computed: {
    ...mapGetters({
      planFeatures: 'pricing/getPlanFeatures',
      getDisplayedProdConfig: 'pricing/getDisplayedProdConfig',
      userDetails: 'pricing/pricingUserDetails',
    }),
    displayedProdConfig() {
      // @ts-ignore
      return this.getDisplayedProdConfig(this.$t('currentPlan'), false)
    },
    planIds() {
      const flipped = Object.entries(PRODUCT_KEYS).map(([key, stringVal]) => [
        stringVal,
        key,
      ])
      const ids: { [key: string]: number } = {}
      flipped.forEach(([key, value]: any) => {
        ids[key] = parseInt(value)
      })
      return ids
    },
  },
  methods: {
    planClicked({ planId, billingCycle }: { planId: number; billingCycle: string }) {
      this.$store.dispatch('user/updateSubscriptionPlan', {
        context: this,
        planId,
        billingCycle,
      })
    },
  },
})
